<app-wrapper>
    <div class="mb-9">
        <div class="mb-4">
            <div class="row g-3">
                <div class="col-auto">
                    <h2>
                        Дашбоард
                    </h2>
                </div>
            </div>
        </div>

        <div class="mb-4">
            <div class="row g-3">
                <div class="col-auto">
                </div>
                <div class="col-auto flex-grow-1">

                </div>
                <div class="col-auto">
                    <button (click)="syncIIKO()" [disabled]="isIIKOSyncing" class="btn btn-primary">
                        <i class="fa-solid fa-sync" [ngClass]="{'fa-spin': isIIKOSyncing}"></i>&nbsp;
                        Синхронизировать с ИИКО
                    </button>
                </div>
            </div>
        </div>


        <div class="row g-5">
            <div class="col-12">
                <div class="card p-4">
                    <app-in-develop></app-in-develop>
                </div>
            </div>
        </div>
    </div>
</app-wrapper>